import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/home.css";

export const StelaPromo: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="stela">
      <div>
        <div className="kicker">Feita para o seu mapa</div>
        <h2 className="display">
          Stela conhece
          <br />
          o seu céu antes de responder
        </h2>
        <p style={{ color: "var(--muted)", marginTop: 14, maxWidth: "50ch" }}>
          Não é um chatbot genérico: cada resposta parte do seu mapa natal, das posições do dia
          e de tudo o que Stela já sabe de você nas conversas anteriores.
        </p>
        <a
          href="#"
          className="btn"
          style={{ marginTop: 22 }}
          onClick={(e) => {
            e.preventDefault();
            navigate("/chat");
          }}
        >
          Conversar agora
        </a>
        <p style={{ color: "var(--muted)", fontSize: 12.5, marginTop: 12 }}>
          Primeiras 3 conversas grátis · depois, por créditos
        </p>
      </div>

      <div className="chat-mock" aria-hidden="true">
        <div className="head">
          <div className="ava">S</div>
          <div>
            <b>Stela</b>
            <span>✦ online · lendo seu mapa</span>
          </div>
        </div>
        <div className="msg ai">
          Boa noite, Igor 🌙 — sabendo do teu Sol em Áries, essa impaciência com a carreira é quase biológica. Me conta: a mudança já tem forma, ou é só pressão?
        </div>
        <div className="msg user">
          Tem forma. Recebi uma proposta ontem.
        </div>
        <div className="typing">
          <i></i><i></i><i></i>
        </div>
      </div>
    </section>
  );
};
